const channel_campaign_statuses_options = [
  { label: "Aktywna", value: "ACTIVE" },
  { label: "Wstrzymana", value: "PAUSED" },
];

export const channel_campaign_statuses = {
  ACTIVE: {
    name: "Aktywna",
    color: "#0abb87",
  },
  PAUSED: {
    name: "Wstrzymana",
    color: "#f2ae49",
  },
  ARCHIVED: {
    name: "Zarchiwizowana",
    color: "#ff0000",
  },
};

export default channel_campaign_statuses_options;
